export default __webpack_public_path__ + "static/media/instIcon.c5a9e6b4.svg";